import React, { useEffect, lazy, Suspense } from "react";
import { Helmet } from "react-helmet-async";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import "./App.css";
import Home from "./WebsitePages/cargopro-home";
import CookieConsent from "./components/CookieConsent";
import RouteSEO from "./components/route-seo";
// Lazy-loaded routes
const FreightSourcingAndReverseAuction = lazy(() =>
  import("./WebsitePages/Solutions/freight-sourcing-and-reverse-auction")
);
const IndentAutomation = lazy(() =>
  import("./WebsitePages/Solutions/indent-automation")
);
const FeaturesPage = lazy(() => import("./WebsitePages/Features/features"));
const Blog = lazy(() => import("./WebsitePages/Blogs/Blog"));
const AboutCargoPro = lazy(() =>
  import("./WebsitePages/AboutCargoPro/about-cargopro")
);
const RevolutionizingLogistics = lazy(() =>
  import("./WebsitePages/Blogs/blog-revolutionizing-logistics")
);
const Invoicing = lazy(() => import("./WebsitePages/Solutions/invoicing"));
const InPlant = lazy(() =>
  import("./WebsitePages/Solutions/in-plant-vehicle-movement")
);
const Pod = lazy(() => import("./WebsitePages/Solutions/pod"));
const Careers = lazy(() => import("./WebsitePages/CareersAtCargoPro/careers"));
const Industries = lazy(() => import("./WebsitePages/Industries/industries"));
const DashboardAndAnalytics = lazy(() =>
  import("./WebsitePages/Solutions/dashboard-and-analytics")
);
const Blog1 = lazy(() =>
  import("./WebsitePages/Blogs/blog-1-revolutionizing-procurement")
);
const Blog2 = lazy(() =>
  import("./WebsitePages/Blogs/blog-2-eco-friendly-logistics")
);
const Blog3 = lazy(() =>
  import("./WebsitePages/Blogs/blog-3-say-goodbye-to-invoiceing-hassles")
);
const Blog4 = lazy(() =>
  import("./WebsitePages/Blogs/blog-4-breaking-barieiers")
);
const Blog5 = lazy(() =>
  import("./WebsitePages/Blogs/blog-5-digital-transformations-strategies")
);
const Blog6 = lazy(() =>
  import("./WebsitePages/Blogs/blog-6-optimizing-resourses")
);
const Blog7 = lazy(() =>
  import("./WebsitePages/Blogs/blog-7-cutting-down-freight-cost")
);
const Blog8 = lazy(() =>
  import("./WebsitePages/Blogs/blog-8-how-to-choose-right-tms")
);
const Blog9 = lazy(() =>
  import("./WebsitePages/Blogs/blog-9-end-to-end-suplly-chain")
);
const Blog10 = lazy(() =>
  import("./WebsitePages/Blogs/blog-10-higher-freight-cost-in-steel-industry")
);
const Blog11 = lazy(() =>
  import("./WebsitePages/Blogs/blog-11-national-logistics-policy-2022")
);
const Blog12 = lazy(() =>
  import("./WebsitePages/Blogs/blog-12-automated-invoicing")
);
const Blog13 = lazy(() =>
  import("./WebsitePages/Blogs/blog-13-benifits-of-automated-indent-management")
);
const Blog14 = lazy(() =>
  import(
    "./WebsitePages/Blogs/blog-14-streamline-yard-management-with-in-plant-optimization"
  )
);
const Blog15 = lazy(() =>
  import(
    "./WebsitePages/Blogs/blog-15-end-to-end-visibility-with-logistics-tracking-solution"
  )
);
const Blog16 = lazy(() =>
  import("./WebsitePages/Blogs/blog-16-data-driven-logistics")
);
const Blog17 = lazy(() =>
  import("./WebsitePages/Blogs/blog-17-digital-proof-of-dilivery")
);
const Blog18 = lazy(() =>
  import("./WebsitePages/Blogs/blog-18-last-mile-delivery-logistics")
);
const Blog19 = lazy(() =>
  import("./WebsitePages/Blogs/blog-19--elevating-warehoouse-efficiency")
);
const Blog20 = lazy(() =>
  import("./WebsitePages/Blogs/blog-20-warehouse-management-system")
);
const Blog21 = lazy(() =>
  import("./WebsitePages/Blogs/blog-21-slreamlining-logistics-operations")
);
const Blog22 = lazy(() =>
  import("./WebsitePages/Blogs/blog-22-seamless-integration-of-transportation")
);
const Blog23 = lazy(() =>
  import("./WebsitePages/Blogs/blog-23-mastering-multi-carrier-shipments")
);
const Blog24 = lazy(() =>
  import("./WebsitePages/Blogs/blog-24-revolutionizing-freight-transport")
);
const RevolutionizingLogisticsBlog = lazy(() =>
  import("./WebsitePages/Blogs/blog-revolutionizing-logistics")
);
const Blog25IndiaLogisticsCosts = lazy(() =>
  import("./WebsitePages/Blogs/blog-25-india-logistics-costs-7-97-gdp")
);
const Blog26DigitalFreightBidding = lazy(() =>
  import("./WebsitePages/Blogs/blog-26-digital-freight-bidding-india")
);
const Blog27TopLogisticsTechnologyTrends2025 = lazy(() =>
  import("./WebsitePages/Blogs/blog-27-top-logistics-technology-trends-2025")
);
const Blog28SMBTMSIndia = lazy(() =>
  import("./WebsitePages/Blogs/blog-28-smb-tms-india")
);
const Blog29AIPoweredTMSIndia = lazy(() =>
  import("./WebsitePages/Blogs/blog-29-ai-powered-tms-india")
);
const Blog30AIRouteOptimization = lazy(() =>
  import("./WebsitePages/Blogs/blog-30-ai-route-optimization-india")
);
const Blog31LogisticsAutomationIndia = lazy(() =>
  import("./WebsitePages/Blogs/blog-31-logistics-automation-india")
);
const Blog32CargoProVsSuperProcure = lazy(() =>
  import("./WebsitePages/Blogs/blog-32-cargopro-vs-superprocure.jsx")
);
const Blog33InPlantVisibility = lazy(() =>
  import("./WebsitePages/Blogs/blog-33-in-plant-visibility-manufacturers-2025")
);
const Blog34SimVsGps = lazy(() =>
  import("./WebsitePages/Blogs/blog-34-sim-vs-gps-tracking-2025.jsx")
);
const Blog35TMSPlatforms = lazy(() =>
  import("./WebsitePages/Blogs/blog-35-tms-platforms-cargopro-2025.jsx")
);
const Blog36CargoProVsAllTMS = lazy(() =>
  import(
    "./WebsitePages/Blogs/blog-36-cargopro-vs-tms-platforms-india-2025.jsx"
  )
);
const Blog37TopLogisticsSoftware = lazy(() =>
  import("./WebsitePages/Blogs/blog-37-top-logistics-software-india-2025.jsx")
);
const Blog38HowToChooseTMS = lazy(() =>
  import("./WebsitePages/Blogs/blog-38-how-to-choose-best-tms-india-2025.jsx")
);
const Blog39TMSVsYMSVsWMS = lazy(() =>
  import("./WebsitePages/Blogs/blog-39-tms-vs-yms-vs-wms-2025.jsx")
);
const Blog40DigitalLogisticsSavings = lazy(() =>
  import(
    "./WebsitePages/Blogs/blog-40-digital-logistics-saves-50-lakhs-2025.jsx"
  )
);
const Blog41IncreaseDispatchCapacity = lazy(() =>
  import(
    "./WebsitePages/Blogs/blog-41-increase-dispatch-capacity-without-more-trucks-2025.jsx"
  )
);
const Blog42PlantVisibility = lazy(() =>
  import(
    "./WebsitePages/Blogs/blog-42-indian-manufacturing-plants-logistics-visibility-2025.jsx"
  )
);
const Blog43DispatchDelays = lazy(() =>
  import(
    "./WebsitePages/Blogs/blog-43-dispatch-delays-manufacturing-plants-2025.jsx"
  )
);
const Blog44TMSCompleteGuide = lazy(() =>
  import(
    "./WebsitePages/Blogs/blog-44-tms-complete-guide-indian-manufacturers-2025.jsx"
  )
);
const Blog45FreightAuction = lazy(() =>
  import(
    "./WebsitePages/Blogs/blog-45-freight-auction-reduce-transportation-cost-2025.jsx"
  )
);
const Blog46IndentManagementSoftware = lazy(() =>
  import(
    "./WebsitePages/Blogs/blog-46-indent-management-software-manufacturers-2025.jsx"
  )
);
const Blog47PlantAutomation = lazy(() =>
  import(
    "./WebsitePages/Blogs/blog-47-plant-automation-indian-manufacturing-2025.jsx"
  )
);
const Blog48ImportExportLogisticsIndia = lazy(() =>
  import(
    "./WebsitePages/Blogs/blog-48-import-export-logistics-india-manufacturers-2025.jsx"
  )
);
const NotFoundPage = lazy(() => import("./404"));
const TermsAndConditions = lazy(() =>
  import("./WebsitePages/TermsAndConditions/terms_and_conditions")
);
const PrivacyPolicy = lazy(() =>
  import("./WebsitePages/PrivacyPolicy/privacy_policy")
);
const FAQ = lazy(() => import("./WebsitePages/CareersAtCargoPro/faq"));
const Tracking = lazy(() => import("./WebsitePages/Solutions/tracking"));
const DispatchPlanning = lazy(() =>
  import("./WebsitePages/Solutions/dispatch-planning")
);
const EximSolutions = lazy(() => import("./WebsitePages/Solutions/exim"));
const ThankYou = lazy(() => import("./WebsitePages/thank-you"));

function ScrollHandler() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "auto" });
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}

function CanonicalLink() {
  const { pathname, search } = useLocation();

  // Normalize legacy patterns to canonical paths
  const normalizePathname = (rawPathname) => {
    // Remove trailing slash except root
    let p =
      rawPathname !== "/" && rawPathname.endsWith("/")
        ? rawPathname.slice(0, -1)
        : rawPathname;

    // Map legacy .html and old slugs to current routes
    const mappings = new Map([
      ["/blogs/blogs.html", "/blogs"],
      ["/blogs/blog6_optimizingResources.html", "/blogs/in-plant-automation"],
      ["/product/indentautomation.html", "/indent-automation"],
      [
        "/blogs/blog14_streamlineYard.html",
        "/blogs/how-to-streamline-yard-management-with-in-plant-optimization",
      ],
      [
        "/blogs/blog20_integrateTransportation.html",
        "/blogs/seamless-integration-of-transportation-and-warehouse-management",
      ],
      ["/company/privacypolicy", "/privacy-policy"],
      [
        "/blogs/blog24_revolutionizingLogistics.html",
        "/blogs/revolutionizing-freight-transport",
      ],
      [
        "/blogs/blog21_StreamliningOperations.html",
        "/blogs/seamless-logistics-operations",
      ],
      ["/blogs/blog11_policy.html", "/blogs/national-logistics-policy-2022"],
      [
        "/blogs/blog8_choosetheRightTMS.html",
        "/blogs/how-to-choose-the-right-tms",
      ],
      ["/product/DashboardNAnalytics", "/dashboard-analytics"],
      [
        "/blogs/blog16_dataDriven.html",
        "/blogs/the-power-of-data-driven-logistics-analytics-and-insights",
      ],
      ["/product/Tracking.html", "/tracking"],
      ["/product/invoicing", "/invoicing"],
      [
        "/blogs/blog12_automatedInvoice.html",
        "/blogs/automated-invoicing-and-simplifying-logistics",
      ],
      ["/product/indent_automation.html", "/indent-automation"],
      ["/company/about", "/about"],
      ["/product/FreightSourcing", "/freight-sourcing-and-reverse-auction"],
      ["/industries/industries", "/industries"],
      ["/blogs/blogs", "/blogs"],
      ["/company/termsncondition.html", "/terms-and-conditions"],
      [
        "/blogs/blog23_multiCarrier.html",
        "/blogs/mastering-multi-carrier-shipments-and-orders",
      ],
      ["/blogs/blog2_EcoFriendly.html", "/blogs/eco-friendly-logistics"],
      ["/company/career.html", "/careers"],
      ["/company/about.html", "/about"],
      ["/blogs/blog18_optimizingDelivery", "/blogs/last-mile-delivery"],
      ["/company/privacypolicy.html", "/privacy-policy"],
      ["/company/career", "/careers"],
      [
        "/blogs/blog14_streamlineYard",
        "/blogs/how-to-streamline-yard-management-with-in-plant-optimization",
      ],
      ["/industries/industries.html", "/industries"],
      ["/blogs/blog17_digitalProof.html", "/blogs/digital-proof-of-delivery"],
      [
        "/blogs/blog3_invoicingHassle.html",
        "/blogs/say-goodbye-to-invoicing-hassles",
      ],
      ["/blog", "/blogs"],
      ["/blogs/blog18_optimizingDelivery.html", "/blogs/last-mile-delivery"],
      [
        "/insights/invoicing-automation",
        "/blogs/automated-invoicing-and-simplifying-logistics",
      ],
      [
        "/blogs/breaking-barriers-digital-logistics",
        "/blogs/digital-solution-challenges",
      ],
      [
        "/blogs/digital-transformation-logistics",
        "/blogs/digital-transformation-strategies",
      ],
      [
        "/blogs/national-logistics-policy",
        "/blogs/national-logistics-policy-2022",
      ],
      ["/insights/eco-friendly-logistics", "/blogs/eco-friendly-logistics"],
      [
        "/blogs/blog19_warehouseEfficiency.html",
        "/blogs/elevating-warehouse-efficiency",
      ],
      [
        "/blogs/blog5_digitalTransformationStrategies.html",
        "/blogs/digital-transformation-strategies",
      ],
      [
        "/product/FreightSourcing.html",
        "/freight-sourcing-and-reverse-auction",
      ],
      [
        "/product/inPlantVehicleMovement.html",
        "/in-plant-vehicle-movement-and-optimization",
      ],
      [
        "/product/inPlantVehicleMovement",
        "/in-plant-vehicle-movement-and-optimization",
      ],
      ["/product/indentautomation", "/indent-automation"],
      ["/product/invoicing.html", "/invoicing"],
      ["/contacts", "/contacts"],
    ]);

    if (mappings.has(p)) return mappings.get(p);
    return p;
  };

  // Force preferred host for canonical to consolidate www/non-www and http/https variants
  const origin = "https://cargopro.ai";
  const canonicalPath = normalizePathname(pathname);
  const shouldDropSearch = (() => {
    if (!search) return false;
    if (canonicalPath === "/blogs") {
      const params = new URLSearchParams(search);
      if (params.has("q")) return true;
    }
    return false;
  })();
  const canonical = `${origin}${canonicalPath}${
    shouldDropSearch ? "" : search || ""
  }`;

  return (
    <Helmet>
      <link rel="canonical" href={canonical} />
    </Helmet>
  );
}

function App() {
  return (
    <Router>
      <ScrollHandler />
      <CanonicalLink />
      <CookieConsent />
      <RouteSEO />
      <Suspense
        fallback={
          <div className="sr-only" role="status" aria-live="polite">
            Loading…
          </div>
        }
      >
        <Routes>
          <Route path="/" element={<Home />} />

          {/* Navbar */}

          {/* Solutions */}
          <Route
            path="/freight-sourcing-and-reverse-auction"
            element={<FreightSourcingAndReverseAuction />}
          />
          <Route path="/indent-automation" element={<IndentAutomation />} />
          <Route path="/invoicing" element={<Invoicing />} />
          <Route
            path="/in-plant-vehicle-movement-and-optimization"
            element={<InPlant />}
          />
          <Route path="/proof-of-delivery" element={<Pod />} />
          <Route
            path="/dashboard-analytics"
            element={<DashboardAndAnalytics />}
          />
          <Route path="/tracking" element={<Tracking />} />
          <Route path="/dispatch-planning" element={<DispatchPlanning />} />
          <Route path="/exim" element={<EximSolutions />} />
          <Route path="/features" element={<FeaturesPage />} />

          {/* Industries */}
          <Route path="/industries" element={<Industries />} />

          {/* Company */}
          <Route path="/careers" element={<Careers />} />
          <Route path="/about" element={<AboutCargoPro />} />

          {/* Blogs */}
          <Route path="/blogs" element={<Blog />} />
          <Route
            path="/blogs/revolutionizing-logistics"
            element={<RevolutionizingLogistics />}
          />
          <Route
            path="/blogs/revolutionizing-procurement"
            element={<Blog1 />}
          />
          <Route path="/blogs/eco-friendly-logistics" element={<Blog2 />} />
          <Route
            path="/blogs/say-goodbye-to-invoicing-hassles"
            element={<Blog3 />}
          />
          <Route
            path="/blogs/digital-solution-challenges"
            element={<Blog4 />}
          />
          <Route
            path="/blogs/digital-transformation-strategies"
            element={<Blog5 />}
          />
          <Route path="/blogs/in-plant-automation" element={<Blog6 />} />
          <Route
            path="/blogs/digitization-helps-cutting-down-freight-cost"
            element={<Blog7 />}
          />
          <Route
            path="/blogs/how-to-choose-the-right-tms"
            element={<Blog8 />}
          />
          <Route
            path="/blogs/big-data-and-predictive-analytics-in-logistics"
            element={<Blog9 />}
          />
          <Route
            path="/blogs/why-freight-cost-is-higher-in-the-steel-industry"
            element={<Blog10 />}
          />
          <Route
            path="/blogs/national-logistics-policy-2022"
            element={<Blog11 />}
          />
          <Route
            path="/blogs/automated-invoicing-and-simplifying-logistics"
            element={<Blog12 />}
          />
          <Route
            path="/blogs/benifits-of-automated-indent-management"
            element={<Blog13 />}
          />
          <Route
            path="/blogs/how-to-streamline-yard-management-with-in-plant-optimization"
            element={<Blog14 />}
          />
          <Route
            path="/blogs/achieving-end-to-end-visibility-with-logistics-tracking-solutions"
            element={<Blog15 />}
          />
          <Route
            path="/blogs/the-power-of-data-driven-logistics-analytics-and-insights"
            element={<Blog16 />}
          />
          <Route path="/blogs/digital-proof-of-delivery" element={<Blog17 />} />
          <Route path="/blogs/last-mile-delivery" element={<Blog18 />} />
          <Route
            path="/blogs/elevating-warehouse-efficiency"
            element={<Blog19 />}
          />
          <Route
            path="/blogs/seamless-integration-of-transportation-and-warehouse-management"
            element={<Blog20 />}
          />
          <Route
            path="/blogs/seamless-logistics-operations"
            element={<Blog21 />}
          />
          <Route
            path="/blogs/how-automated-invoicing-in-simplifying-logistics"
            element={<Blog22 />}
          />
          <Route
            path="/blogs/mastering-multi-carrier-shipments-and-orders"
            element={<Blog23 />}
          />
          <Route
            path="/blogs/revolutionizing-freight-transport"
            element={<Blog24 />}
          />

          <Route
            path="/blogs/india-logistics-costs-7-97-gdp"
            element={<Blog25IndiaLogisticsCosts />}
          />

          <Route
            path="/blogs/digital-freight-bidding-india-future-of-automated-logistics"
            element={<Blog26DigitalFreightBidding />}
          />

          <Route
            path="/blogs/revolutionizing-logistics"
            element={<RevolutionizingLogisticsBlog />}
          />

          <Route
            path="/blogs/top-logistics-technology-trends-2025"
            element={<Blog27TopLogisticsTechnologyTrends2025 />}
          />

          <Route
            path="/blogs/why-small-mid-sized-businesses-need-tms-india"
            element={<Blog28SMBTMSIndia />}
          />

          <Route
            path="/blogs/ai-powered-tms-future-smart-logistics-india-2025"
            element={<Blog29AIPoweredTMSIndia />}
          />

          <Route
            path="/blogs/ai-route-optimization-indian-transport-2025"
            element={<Blog30AIRouteOptimization />}
          />

          <Route
            path="/blogs/logistics-automation-india-2025-cargopro-tms"
            element={<Blog31LogisticsAutomationIndia />}
          />

          <Route
            path="/blogs/cargopro-vs-superprocure-best-tms-for-manufacturers-2025"
            element={<Blog32CargoProVsSuperProcure />}
          />

          <Route
            path="/blogs/in-plant-visibility-manufacturers-2025"
            element={<Blog33InPlantVisibility />}
          />

          <Route
            path="/blogs/sim-vs-gps-tracking-2025-guide"
            element={<Blog34SimVsGps />}
          />

          <Route
            path="/blogs/why-cargopro-leads-top-tms-platforms-2025"
            element={<Blog35TMSPlatforms />}
          />

          <Route
            path="/blogs/cargopro-vs-tms-platforms-india-2025"
            element={<Blog36CargoProVsAllTMS />}
          />

          <Route
            path="/blogs/top-logistics-software-platforms-india-2025"
            element={<Blog37TopLogisticsSoftware />}
          />

          <Route
            path="/blogs/how-to-choose-best-tms-india-2025"
            element={<Blog38HowToChooseTMS />}
          />

          <Route
            path="/blogs/tms-vs-yms-vs-wms-2025"
            element={<Blog39TMSVsYMSVsWMS />}
          />

          <Route
            path="/blogs/digital-logistics-saves-50-lakhs-2025"
            element={<Blog40DigitalLogisticsSavings />}
          />

          <Route
            path="/blogs/increase-dispatch-capacity-without-more-trucks-2025"
            element={<Blog41IncreaseDispatchCapacity />}
          />

          <Route
            path="/blogs/indian-manufacturing-plants-logistics-visibility-2025"
            element={<Blog42PlantVisibility />}
          />

          <Route
            path="/blogs/dispatch-delays-manufacturing-plants-2025"
            element={<Blog43DispatchDelays />}
          />

          <Route
            path="/blogs/tms-complete-guide-indian-manufacturers-2025"
            element={<Blog44TMSCompleteGuide />}
          />

          <Route
            path="/blogs/freight-auction-reduce-transportation-cost-2025"
            element={<Blog45FreightAuction />}
          />

          <Route
            path="/blogs/indent-management-software-complete-guide-manufacturers-2025"
            element={<Blog46IndentManagementSoftware />}
          />

          <Route
            path="/blogs/plant-automation-indian-manufacturing-2025"
            element={<Blog47PlantAutomation />}
          />

          <Route
            path="/blogs/import-export-logistics-india-manufacturers-2025"
            element={<Blog48ImportExportLogisticsIndia />}
          />

          {/* Contacts */}
          <Route path="/contacts" element={<Careers />} />

          {/*Terms and Conditions */}
          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditions />}
          />

          {/* Privacy Policy */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />

          <Route path="/faq" element={<FAQ />} />

          <Route path="/thank-you" element={<ThankYou />} />

          {/* Catch-all route */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
